/**
 * @generated SignedSource<<41bdd423c26bd24d8240d8e66e7458cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDomainName_company$data = {
  readonly _id: string;
  readonly id: string;
  readonly logo: {
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly name: string | null | undefined;
  readonly nameFriendly: string | null | undefined;
  readonly " $fragmentType": "useDomainName_company";
};
export type useDomainName_company$key = {
  readonly " $data"?: useDomainName_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDomainName_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useDomainName_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameFriendly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "logo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "fitIn",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": "url(fitIn:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "b974016e2ead84ce6a9a34b7553a7897";

export default node;
